import React from 'react';
import './info-tag.scss';

const InfoTag = props => {
    return (
        <div className={'info-tag-holder'}>
            <i className={'tag-icon '+props.tagIconClass} />
            {props.info?<span className='info-tag-text'>{props.info}</span>:null}
        </div>
    )
};

export default InfoTag;